export default __webpack_public_path__ + "757d835fa506af5f996666de89d8162a.png";